export const PROJECT_TYPE = {
  GROUP_MC: 222,
  TRACKER: 444,
} as const;

export const SURVEY_STATUS = {
  DRAFT: 11,
  SCHEDULED: 12,
  LIVE: 22,
  PAUSE: 33,
  CLOSE: 44,
  INVOICED: 55,
} as const;

export const SURVEY_STATUS_LABELS = Object.fromEntries(
  Object.entries(SURVEY_STATUS).map(([key, value]) => [value, key]),
) as Record<number, string>;
